module.exports = __webpack_public_path__ + "img/Overview-icon.98a57b64.svg";